import { createFocusTrap } from 'focus-trap';
import { events } from '@/constants';
import { on, emit } from '@/neon/events';

const {
  strings: { products: strings },
} = theme;

const selectors = {
  stars: '.spr-summary-starrating',
  totalReviewsContainer: '.spr-summary-actions-togglereviews',
};

const reviewsDrawer = node => {
  const closeBtn = node.querySelector('[data-reviews-close]');
  var focusTrap = createFocusTrap(node, { allowOutsideClick: true });

  closeBtn.addEventListener('click', close);

  // const starRating = node.querySelector(selectors.stars);

  // const totalReviewsContainer = node.querySelector(
  //   selectors.totalReviewsContainer
  // );

  // let totalReviews = strings.product.write_review;

  // if (totalReviewsContainer) {
  //   const totalReviewsString = totalReviewsContainer.innerText;
  //   totalReviews = `${totalReviewsString.match(/\d+/g)} ${
  //     strings.product.total_reviews
  //   }`;
  // }

  // emit(events.reviews.added, () => ({
  //   starRating,
  //   totalReviews,
  // }));

  const overlayHideListener = on('drawerOverlay:hiding', () => close(false));

  window.addEventListener('keydown', handleKeyboard);

  function handleKeyboard(e) {
    if (!node.classList.contains('is-visible')) return;

    if (e.key == 'Escape' || (e.keyCode === 27 && drawerOpen)) {
      close();
    }
  }

  const open = () => {
    node.classList.add('is-visible');
    emit('drawerOverlay:show');

    const reviewsToggle = node.querySelector(
      '.spr-summary-actions-togglereviews'
    );

    if (reviewsToggle) {
      reviewsToggle.tabIndex = -1;
    }

    setTimeout(() => {
      focusTrap.activate();
    }, 50);
  };

  const close = (hideOverlay = true) => {
    hideOverlay && emit('drawerOverlay:hide');
    node.classList.remove('is-visible');

    setTimeout(() => {
      focusTrap.deactivate();
    }, 50);
  };

  const unload = () => {
    closeBtn.removeEventListener('click', close());
    overlayHideListener();
  };

  return { unload, open };
};

export default reviewsDrawer;
